"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _SecondaryInfo = require("./SecondaryInfo");
var _PriceInfo = require("./PriceInfo");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MainInfo = function MainInfo(props) {
  var product = props.product;
  var SecondaryInfo = props.secondaryInfoComponent || _SecondaryInfo.SecondaryInfo;
  var PriceInfo = props.priceInfoComponent || _PriceInfo.PriceInfo;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SecondaryInfo, {
    product: product
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    fontWeight: 600,
    fontSize: "1.75rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, product.name), /*#__PURE__*/_react.default.createElement(_core.Box, {
    marginTop: 1.5,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, product.category.name), /*#__PURE__*/_react.default.createElement(PriceInfo, _extends({}, props, {
    product: product
  }))), props.renderExtraInfo && props.renderExtraInfo(product));
};
exports.MainInfo = MainInfo;